import React, { Component, Fragment } from 'react'
import sortBy from 'lodash/sortBy'
import each from 'lodash/each'
import find from 'lodash/find'
import get from 'lodash/get'
import setQuery from 'set-query-string'
import { parseQuery, setGuestParams } from '../../utils'
import API from '../../api'
import { createUrl } from '../../localized-urls'
import { FormattedMessage, intlShape, injectIntl } from 'react-intl'
import PriceConverter from '../helpers/PriceConverter'
import BoatTrips from './BoatTrips'
import Pagination from 'react-js-pagination'
import ShopSlider from './ShopSlider'
import PromotionCorner from '../helpers/PromotionCorner'
import ReviewLabel from '../helpers/ReviewLabel'
import SellingProposition from './SellingProposition'
import OperatorSwitch from './OperatorSwitch'
import PlaceholderBoat from './PlaceholderBoat'
import messages from '../../messages'

import { toast } from 'react-toastify'

const PAGE_SIZE = 10

class BoatComponent extends Component {
  constructor(props) {
    super(props)

    const query = parseQuery()

    this.state = {
      loading: true,
      page: query && query.page ? +query.page : 1,
      shops: [],
      pageCount: 0,
    }

    this.tripContainerRef = React.createRef()
  }

  componentDidMount() {
    this.getTrips()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams) ||
      prevProps.getNewData !== this.props.getNewData
    ) {
      this.setState({
        page: 1,
        loading: true,
      }, this.getTrips)
    }
  }

  getTrips = () => {
    const { model, pk } = this.props

    let highlightSlug = ''

    if(window.highlightedShopSlug && window.highlightedShopSlug !== '') {
      highlightSlug = window.highlightedShopSlug + '/'
    }

    return API(`search/${model.toLowerCase()}/${pk}/liveaboards/${highlightSlug}`).get({
      page: this.state.page,
      page_size: PAGE_SIZE,
      ...this.props.selectedParams,
    }).then((data) => {
      const shops = data.results

      each(shops, function(shop) {
        if(shop.teaser) {
          shop.teaser = shop.teaser.replace(/<h2>/g, '')
            .replace(/<li>/g, '')
            .replace(/<strong>/g, '')
            .replace(/<ul>/g, '')
            .replace(/<p>/g, '')
            .replace(/<\/li>/g, '\n')
            .replace(/<\/strong>/g, '')
            .replace(/<\/ul>/g, '')
            .replace(/<\/p>/g, '\n')
            .replace(/<\/h2>/g, '\n')
            .replace(/<\/h3>/g, '\n')
            .replace(/<\/h4>/g, '\n')
        }

        if(shop.promotions) {
          if(find(shop.promotions, { isMain: true })) {
            shop.promotions = sortBy(shop.promotions, 'isMain').reverse()
          } else {
            shop.promotions = sortBy(shop.promotions, 'value').reverse()
          }
        }
      })

      this.props.setNumberOfItems(data.count, 'numberOfBoats')

      this.setState({
        shops,
        loading: false,
        numberOfTrips: data.count,
      })
    }).catch(() => {
      this.setState({
        loading: false,
        numberOfTrips: 0,
        shops: [],
      })

      toast.error(<FormattedMessage id='went_wrong' defaultMessage='Something went wrong' />, {
        position: toast.POSITION.TOP_CENTER,
      })
    })
  }

  onPageChange = (page) => {
    window.scrollTo(0, this.tripContainerRef.current.offsetTop)
    setQuery({ page })
    this.setState({
      page,
      loading: true,
    }, this.getTrips)
  }

  queriesForWidget() {
    if(!this.props.isWidget) {
      setGuestParams(this.props.selectedParams)
      return null
    }

    const params = parseQuery()

    let query = `?utm_campaign=WW-ALL-ALL-DI-Affiliates&utm_medium=widget&utm_content=${params.popup ? 'search_modal' : 'search_iframe'}&`

    if(params.aid) {
      query += `utm_source=affiliate_${params.aid}&aid=${params.aid}&`

      if(params.cid) {
        query += `cid=${params.cid}`
      }
    }

    return query
  }

  createShopUrl(shop) {
    return createUrl('la_page', {
      location: shop.referenceLocationCountrySlug || shop.countrySlug,
      slug: shop.slug || shop.shopSlug,
    }, this.queriesForWidget())
  }

  render() {
    const { intl, model, pk, insurance } = this.props

    const insuranceTooltip = intl.formatMessage(messages.diveInsuranceDescription, { price: get(insurance, 'limitPrice', 'n/a') })

    if(this.state.loading) {
      return (
        <Fragment>
          {
            [...new Array(10)].map((_, i) => {
              return (<PlaceholderBoat key={i} />)
            })
          }
        </Fragment>
      )
    }
    return (
      <div ref={this.tripContainerRef} className='results'>
        {
          this.state.shops && this.state.shops.map((shop, index) => {
            return (
              <Fragment key={shop.id}>
                <div className={`boat search-page-item-card ${shop.isHighlighted ? 'highlighted' : ''}`}>
                  <div className='boat-info'>
                    <div className='photo-slider'>
                      <ShopSlider slug={shop.slug} shopUrl={this.createShopUrl(shop)} background={shop.backgrounds.GridSearchResultDesktop} />
                      <span className={`heart ${shop.isWishlist ? 'active' : ''}`}
                        data-shop-slug={shop.slug}
                        data-type='Shop'
                        data-in-wishlist={shop.isWishlist}
                        data-wishlist-id={shop.isWishlist} />
                      {
                        shop.promotions && shop.promotions.length
                          ? (<PromotionCorner {...shop.promotions[0]} />)
                          : ''
                      }
                    </div>
                    <div className='shop-info' onClick={(e) => {
                      e.stopPropagation()
                      window.open(this.createShopUrl(shop), '_blank')
                    }}>
                      <div className='shop-head'>
                        <a className='shop-title' target='_blank' href={this.createShopUrl(shop)}>
                          <span>{ shop.title }</span>
                        </a>
                        <ReviewLabel
                          scubaTribe={shop.scubaTribe}
                          shopKind={shop.kind}
                          padiRating={shop.numberOfReviews}
                          tripAdvisor={shop.tripadvisor}
                          urlParams={{ location: shop.referenceLocationCountrySlug || shop.countrySlug, slug: shop.slug || shop.shopSlug }}
                        />
                        <div className='amenities-top'>
                          {
                            shop.parameters.slice(0, 2).map((param) => {
                              if(param.id !== 191) {
                                return (
                                  <p key={param.id}>
                                    <i className={`font-icons am-icon${param.id == 206 || param.id == 205 ? ' nitrox-icon' : ''}${param.id == 49 || param.id == 48 ? ' icon-wifi' : ''}`} />
                                    { param.title }
                                  </p>
                                )
                              }
                            })
                          }
                          {shop.includeFreeDiveInsurance &&
                            <p className='green tooltip-wrapper-block' data-tip={insuranceTooltip}>
                              <i className='font-icons icon-insurance am-icon' />
                              <FormattedMessage id='free_insurance' defaultMessage='Free dive insurance' />
                              <i className='font-icons info-icon' />
                            </p>
                          }
                        </div>
                      </div>

                      <div className='shop-desc'>
                        <p className='shop-desc-text'>{ shop.teaser ? shop.teaser.slice(0, 333) : '' }
                          {shop.isInproperDates && shop.isAvailable ? (
                            <span className='dates-warn'>
                              <i className='font-icons icon-warning' />
                              <FormattedMessage id='dates_not_match_search' defaultMessage='Dates do not match your search criteria' />
                            </span>
                          ) : '' }
                          {!shop.isAvailable ? (<span className='dates-warn'>
                            <i className='font-icons icon-warning' />
                            <FormattedMessage id='no_trips_with_availability' defaultMessage='No trips with availability for your number of guests' />
                          </span>) : ''}
                        </p>
                        <div className='prices'>
                          {
                            shop.minimumPrice ? (
                              <div className='price'>
                                <p className='cur-price'>
                                  <small><FormattedMessage id='from' defaultMessage='From' /></small>
                                  <strong><PriceConverter amount={shop.minimumPrice} /></strong>
                                </p>
                                <p className='price-info'><FormattedMessage id='per_day' defaultMessage='per day' /></p>
                              </div>) : '' }
                          <button className='btn-red'><FormattedMessage id='view_boat' defaultMessage='View boat' /></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <BoatTrips
                    isWidget={this.props.isWidget}
                    model={model}
                    modelId={pk}
                    selectedParams={this.props.selectedParams}
                    id={shop.id} currency={shop.currency}
                    shopSlug={shop.slug}
                    countrySlug={shop.referenceLocationCountrySlug}
                    insurance={shop.includeFreeDiveInsurance && insurance} />
                </div>
                { !this.props.parentElement && (index === 2 || this.state.shops.length < 3 && this.state.shops.length === index + 1) ? <SellingProposition /> : ''}
              </Fragment>)
          })
        }
        {
          !this.state.loading ? (<OperatorSwitch {...this.props.resortDetails} />) : ''
        }
        { this.state.numberOfTrips > 10
          ? (<div className='pagination-wrap'>
            <Pagination
              activePage={this.state.page}
              innerClass='custom-pagination'
              itemsCountPerPage={PAGE_SIZE}
              itemClassPrev='prev'
              itemClassNext='next'
              prevPageText=''
              nextPageText=''
              itemClassFirst='hidden'
              itemClassLast='hidden'
              totalItemsCount={this.state.numberOfTrips}
              pageRangeDisplayed={5}
              onChange={this.onPageChange}
            />
          </div>) : ''
        }
      </div>
    )
  }
}

BoatComponent.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(BoatComponent)
